//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../no/RegionPointList.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[1,"DivideCurve",0,"Section",0],[1,"Faces",0,"ScCollector",0],[1,"ProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[1,"Regions",0,"RegionPointList",0]],[[["projectionType","projectionVector"],"SetProjectionDirection",{},2,0],[["regionPoints"],"SetRegionPoints",{},1,0],[["targetBody","regionPoint"],"SetPointToRegionList",{},2,0],[["count"],"CreateRegionBody",{R_:{regionBody:"TaggedObject[]"}},0,0],[[],"DeleteRegionBody",{},0,0],[["roomFaceItemName"],"SetRoomFaceItemName",{},1,0]],[]];
SPLM.Features.AECDesign.RoomFaceListItemBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.RoomFaceListItemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;